import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database"; // New import for Realtime Database

const firebaseConfig = {
    apiKey: "AIzaSyCL-5ffVmfDAQ8fMkmG7cqR95wsRemB3gs",
    authDomain: "zen-sight.firebaseapp.com",
    projectId: "zen-sight",
    storageBucket: "zen-sight.firebasestorage.app",
    messagingSenderId: "786232960350",
    appId: "1:786232960350:web:6d9f42592b590dafb9dbcf",
    measurementId: "G-YQRYRQEBJ0"
  };

// Initialize Firebase

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app); // Export Firebase Auth
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);
export const rtdb = getDatabase(app); // Initialize and export RTDB

